var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 15" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M14.4 0h-12C1.5.1.7.7.4 1.6V15c.1 0 2.6-4 3.4-4h10.7c.7-.1 1.1-.6 1.1-1.3V1.6C15.5.9 15.2 0 14.4 0zM8.5 7h-5V5h5v2zm4-3h-9V2h9v2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Commented.svg